import { useTranslation } from "react-i18next"
import type { FC } from "react"

import type { PowerlineFeatureProps } from "types/geolocation.types"

import { formatSeasonalAmpacityLines } from "helpers/utils/seasonalAmpacity"
import useRoutes from "helpers/hooks/useRoutes"
import EntityPopup, { type EntityPopupField } from "./EntityPopup"
import { getFeatureFields } from "./featureFields"

interface PowerlinePopupProps {
  data: PowerlineFeatureProps
  hideButton?: boolean
}

const PowerlinePopup: FC<PowerlinePopupProps> = ({ data, hideButton }) => {
  const { i18n, t } = useTranslation()
  const { baseOrgURL } = useRoutes()

  // Seasonal ampacity replaces the (deprecated) nominal ampacity slot.
  const seasonalLines = formatSeasonalAmpacityLines(
    data.ampacity_seasonal,
    i18n.resolvedLanguage,
  )
  const ampacityField: EntityPopupField | undefined = seasonalLines.length
    ? { label: t("geo_info.AMPACITY_NOMINAL"), type: "text", value: seasonalLines }
    : undefined

  const fields = getFeatureFields(
    "Powerline",
    data,
    t,
    ampacityField && { ampacity_nominal: ampacityField },
  )

  return (
    <EntityPopup
      entity="powerline"
      name={data.name}
      fields={fields}
      id={data.id}
      href={hideButton ? undefined : `${baseOrgURL}/powerlines/${data.id}`}
    />
  )
}

export default PowerlinePopup
